/* Silayibazi quick add: the + on a product card opens a slide-up panel with photo, name, price and sizes. */
(function () {
  if (window.__sbQuick) return;
  window.__sbQuick = true;
  var root = null, panel = null, body = null, lastBtn = null, closeT = 0;
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'sb-qs';
    root.hidden = true;
    root.innerHTML = '<div class="sb-qs__overlay" data-sb-qs-close></div>' +
      '<div class="sb-qs__panel" role="dialog" aria-modal="true" aria-label="Quick add">' +
      '<span class="sb-qs__grab" aria-hidden="true"></span>' +
      '<button type="button" class="sb-qs__close" data-sb-qs-close aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg></button>' +
      '<div class="sb-qs__body"></div></div>';
    document.body.appendChild(root);
    panel = root.querySelector('.sb-qs__panel');
    body = root.querySelector('.sb-qs__body');
  }
  function open(btn) {
    var tpl = btn.parentElement && btn.parentElement.querySelector('template.sb-qa-tpl');
    if (!tpl) return;
    build();
    clearTimeout(closeT);
    lastBtn = btn;
    body.innerHTML = tpl.innerHTML;
    root.hidden = false;
    document.documentElement.classList.add('sb-qs-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    var first = body.querySelector('button:not([disabled])');
    setTimeout(function () { try { (first || panel).focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close(fast) {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sb-qs-open');
    clearTimeout(closeT);
    closeT = setTimeout(function () { root.hidden = true; body.innerHTML = ''; }, fast ? 0 : 320);
    if (!fast && lastBtn) { try { lastBtn.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-sb-qa]');
    if (b) { e.preventDefault(); e.stopPropagation(); open(b); return; }
    if (t.closest('[data-sb-qs-close]')) { e.preventDefault(); close(); }
  }, true);
  /* A size tap is handled by the bag script (it adds the item and opens the bag); just slide this panel away. */
  function onPick(e) {
    var t = e.target;
    var s = t && t.closest && t.closest('.sb-qs__sizes button[type=submit]');
    if (s && !s.disabled) setTimeout(function () { close(true); }, 30);
  }
  document.addEventListener('pointerup', onPick, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Enter' || e.key === ' ') onPick(e);
  }, true);
  var sy = 0;
  document.addEventListener('touchstart', function (e) { if (root && !root.hidden && panel.contains(e.target)) sy = e.touches[0].clientY; }, { passive: true });
  document.addEventListener('touchend', function (e) { if (root && !root.hidden && sy && e.changedTouches[0].clientY - sy > 70) close(); sy = 0; }, { passive: true });
})();
